import React from 'react';

import { Text, i18n, tokens, Services } from '@simplybenefits/sb-ui-library';
import { numberWithCommas } from '../../services/helpers.js';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import store from '../../redux/store.js';

/**
 *
 * @param {*} props
 */
export default function Efap({ classes, expanded, efap, handleChange, theme, isStudent, planDesign }) {
    const styles = {
        kiiRow: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            marginBottom: 5
        },
        column: {
            display: 'flex',
            flexDirection: 'column'
        }
    };
    
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('efap')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('efap') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>{ i18n.t(tokens.titles["employee assistance program"])}</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>

                    {
                        efap.isEligible === 1 ?
                            <React.Fragment>
                                {
                                    efap.carrier.toUpperCase() === 'KII' ?
                                        <div style={ styles.column }>
                                            <div style={{ marginBottom: 10 }}>
                                                {
                                                    efap.includeEmployeeAssistance ?
                                                        <>
                                                            <Text small bold margin="20px 0px 10px 0px">
                                                                { i18n.t(tokens.labels.coverage.welcomeToKii) }
                                                            </Text>
                                                            <Text small bold margin="0px 0px 10px 0px">
                                                                { i18n.t(tokens.labels.coverage.yourMembershipIncludes) } 
                                                            </Text>

                                                            <div style={ styles.kiiRow }>
                                                                <Text small margin="0px 10px 0px 0px">
                                                                    •
                                                                </Text>
                                                                <Text small>
                                                                    { i18n.t(tokens.labels.coverage.kiiEfap) } 
                                                                </Text>
                                                            </div>

                                                            <div style={ styles.kiiRow }>
                                                                <Text small margin="0px 10px 0px 0px">
                                                                    •
                                                                </Text>
                                                                <Text small>
                                                                    { i18n.t(tokens.labels.coverage.kiiMentalHealthAndWellness) } 
                                                                </Text>
                                                            </div>

                                                            <div style={ styles.kiiRow }>
                                                                <Text small margin="0px 10px 0px 0px">
                                                                    •
                                                                </Text>
                                                                <Text small>
                                                                    { i18n.t(tokens.labels.coverage.kiiReferenceLibrary) } 
                                                                </Text>
                                                            </div>

                                                            <div style={ styles.kiiRow }>
                                                                <Text small margin="0px 10px 0px 0px">
                                                                    •
                                                                </Text>
                                                                <Text small>
                                                                    { i18n.t(tokens.labels.coverage.kiiHealthAndWellnessNewsletter) } 
                                                                </Text>
                                                            </div>
                                                            <Text small bold margin="10px 0px 10px 0px">
                                                                { i18n.t(tokens.labels.coverage.kiiNoCostToYou) } 
                                                            </Text>
                                                        </>
                                                        : null
                                                }

                                                {
                                                    efap.includeEldercare ?
                                                        <a href="https://d6hvupc5g7lnm.cloudfront.net/files/Kii_Eldercare_En.pdf" style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">
                                                            <Text
                                                                small
                                                                bold
                                                                margin="5px 0px 0px 0px"
                                                                customStyle={{ textDecoration: 'underline' }}
                                                            >
                                                                { i18n.t(tokens.labels.coverage.eldercareBenefitsIncluded) }
                                                            </Text>
                                                        </a>
                                                        : null
                                                }

                                                {
                                                    efap.includeMedicalSecondOpinion ?
                                                        <a href="https://d6hvupc5g7lnm.cloudfront.net/files/Kii_Medical_Second_Opinion_En.pdf" style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">
                                                            <Text
                                                                small
                                                                bold
                                                                margin="5px 0px 0px 0px"
                                                                customStyle={{ textDecoration: 'underline' }}
                                                            >
                                                                { i18n.t(tokens.labels.coverage.medicalSecondOpinionBenefitsIncluded) }
                                                            </Text>
                                                        </a>
                                                        : null
                                                }

                                                {
                                                    efap.includeMentalHealthOnDemand ?
                                                        <Text
                                                            small
                                                            bold
                                                            margin="5px 0px 0px 0px"
                                                        >
                                                            { i18n.t(tokens.labels.coverage.mentalHealthOnDemandBenefitsIncluded) }
                                                        </Text>
                                                        : null
                                                }
                                            </div>

                                            {
                                                efap.includeEmployeeAssistance ?
                                                    <>
                                                        <a href="tel:1-866-814-0018" style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">
                                                            <Text
                                                                margin="5px 0px 0px 0px"
                                                                small
                                                                wrap={false}
                                                            >
                                                                {i18n.t(tokens.labels.coverage.phoneNumber)} <Text small customStyle={{ textDecoration: 'underline', display: 'inline' }}>{ Services.constants.phoneNumbers.Kii.number }</Text> 
                                                            </Text>
                                                        </a>

                                                        <a href={ i18n.locale === 'fr' ? "https://secure.kiihealth.ca/register?eac=&lang=fr" : "https://secure.kiihealth.ca/register?eac=&lang=en"} style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">
                                                            <Text
                                                                small
                                                                margin="5px 0px 0px 0px"
                                                                customStyle={{ textDecoration: 'underline' }}
                                                            >
                                                                { i18n.t(tokens.labels.coverage.registerForKii) }
                                                            </Text>
                                                        </a>
                                                    </>
                                                    : null
                                            }
                                        </div>  
                                        :
                                        null
                                }

                                {
                                    efap.carrier.toUpperCase() === 'ADVICA' ?
                                        <div style={ styles.column }>
                                            <Text small bold margin="20px 0px 10px 0px">
                                                { i18n.t(tokens.labels.coverage.employeeAssistanceProgramAdvica) }
                                            </Text>

                                            {
                                                efap.includeEldercare ?
                                                    <Text small bold margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.eldercareBenefitsIncluded) }</Text>
                                                    :
                                                    null
                                            }

                                            {
                                                efap.includeMedicalSecondOpinion ?
                                                    <Text small bold margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.medicalSecondOpinionBenefitsIncluded) }</Text>
                                                    :
                                                    null
                                            }

                                            {
                                                efap.includeMentalHealthOnDemand ?
                                                    <Text small bold margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.mentalHealthOnDemandBenefitsIncluded) }</Text>
                                                    :
                                                    null
                                            }

                                            {
                                                efap.includeEmployeeAssistance ?
                                                    <>
                                                        <a href="https://d6hvupc5g7lnm.cloudfront.net/files/AdvicaEfapGuide.pdf" download="EFAP Guide.pdf" style={{ textDecoration: 'none', marginTop: 10 }} target="_blank" rel="noopener noreferrer">
                                                            <Text
                                                                color={store.getState().whitelabel.secondaryColor || theme.colors.skyBlue}
                                                                small
                                                                display="block"
                                                            >
                                                                { i18n.t(tokens.labels.coverage.efapGuide) }
                                                            </Text>
                                                        </a>

                                                        <a href="https://advicahealth.com/simplybenefitsemployeeplan" style={{ textDecoration: 'none' }} target="_blank"
                                                            rel="noopener noreferrer">
                                                            <Text
                                                                color={store.getState().whitelabel.secondaryColor || theme.colors.skyBlue}
                                                                small
                                                                display="block"
                                                            >
                                                                { i18n.t(tokens.labels.coverage.learnMoreAboutEfap) }
                                                            </Text>
                                                        </a>
                                                    </>
                                                    : null
                                            }

                                            {
                                                Boolean(efap.includeMentalHealthOnDemand) &&
                                                    <a href="https://advicahealth.com/simplybenefitsementalhealth" style={{ textDecoration: 'none' }} target="_blank"
                                                        rel="noopener noreferrer">
                                                        <Text
                                                            color={store.getState().whitelabel.secondaryColor || theme.colors.skyBlue}
                                                            small
                                                            display="block"
                                                        >
                                                            { i18n.t(tokens.labels.coverage.learnMoreAboutMentalHeathOnDemand) }
                                                        </Text>
                                                    </a>
                                            }

                                            <a href="tel:1-888-598-7655" style={{ textDecoration: 'none' }} target="_blank"
                                                rel="noopener noreferrer">
                                                <Text
                                                    color={store.getState().whitelabel.secondaryColor || theme.colors.skyBlue}
                                                    small
                                                    bold
                                                >
                                                    { i18n.t(tokens.labels.coverage.callAdvica) }
                                                </Text>
                                            </a>
                                        </div>
                                        :
                                        null
                                }

                                {
                                    efap.carrier.toUpperCase() === 'DIALOGUE' ?
                                        <div style={ styles.column }>
                                            <Text small bold margin="20px 0px 10px 0px">
                                                { i18n.t(tokens.labels.coverage.employeeAssistanceProgramDialogue) }
                                            </Text>

                                            {
                                                efap.includeEldercare ?
                                                    <Text small bold margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.eldercareBenefitsIncluded) }</Text>
                                                    :
                                                    null
                                            }

                                            {
                                                efap.includeMedicalSecondOpinion ?
                                                    <Text small bold margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.medicalSecondOpinionBenefitsIncluded) }</Text>
                                                    :
                                                    null
                                            }

                                            {
                                                efap.includeMentalHealthOnDemand ?
                                                    <Text small bold margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.mentalHealthOnDemandBenefitsIncluded) }</Text>
                                                    :
                                                    null
                                            }

                                            <Text small bold margin="15px 0px 10px 0px">
                                                { i18n.t(tokens.labels.coverage.dialogueEfapAccess) }
                                            </Text>

                                            <ul style={{ listStyle: 'disc', paddingLeft: '16px', marginLeft: '1px' }}>
                                                <li><Text small margin="0px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.mentalHealthServices) }</Text></li>
                                                <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.familyAndRelationships) }</Text></li>
                                                <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.workAndCareer) }</Text></li>
                                                <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.legalServices) }</Text></li>
                                                <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.financialServices) }</Text></li>
                                            </ul>

                                            <Text small margin="10px 0px 0px 0px">
                                                <a href="https://pages-support.dialogue.co/eap-signup/" target="_blank" rel="noopener noreferrer">{ i18n.t(tokens.labels.coverage.learnMoreAboutEfap) }</a>
                                            </Text>
                                        </div>
                                        :
                                        null
                                }

                                {
                                    planDesign.accessCode ?
                                        <Text
                                            small
                                            margin="5px 0px 0px 0px"
                                        >
                                            { i18n.t(tokens.labels.planDesign.accessCode) }: { planDesign.accessCode }
                                        </Text>
                                        : null
                                }
                            </React.Fragment>
                            :
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    { i18n.t(tokens.labels.coverage.ineligibleForBenefit)}
                                </Text>
                            </div>
                    }
                </AccordionDetails>
            </Accordion>
        </div>
    );
}